import styled from 'styled-components/macro';

const HeaderContainer = styled.div`
  align-items: center;
  border: 3px solid hsl(217, 16%, 45%);
  border-radius: 10px;
  display: flex;
  justify-content: space-between;
  max-width: 80%;
  width: 800px;
  padding: 1.5rem 2rem;
`;

export default HeaderContainer;
